import React from 'react';
import { Modal } from 'antd';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import OWButton from '../ow_button/OWButton';
import EntityAddRequestDetails from './EntityAddRequestDetails';
import ApprovalHierarchyDisplayEntityRequest from '../approval_hierarchy_display_entity_request/ApprovalHierarchyDisplayEntityRequest';

// Read-only detail view for a request (used by the "View" action, e.g. on approved requests).
// Requests that went through an approval hierarchy also expose the approvers link, so who signed off
// — and who was still pending — stays visible after the request settles.
function ViewEntityAddRequestModal({ visible, record, hideModal }) {
	return (
		<Modal
			visible={visible}
			width={600}
			title={`Review Request: ${nullSafeGetOrElse('displayName', record, '')}`}
			onCancel={hideModal}
			closable={true}
			destroyOnClose={true}
			footer={
				// Right-aligned rather than justify-between: the approvers link renders nothing without a
				// hierarchy, and a lone justified child would drag "Done" over to the left.
				<div className="flex flex-row items-center justify-end" style={{ gap: '16px' }}>
					<ApprovalHierarchyDisplayEntityRequest record={record} />
					<OWButton key="done" type="primary" size="large" onClick={hideModal}>
						Done
					</OWButton>
				</div>
			}
		>
			<EntityAddRequestDetails record={record} />
		</Modal>
	);
}

export default ViewEntityAddRequestModal;
